module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp1_0.9134ee64.png";